// necessary dependencies //
import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
// css //
import styles from './Template.module.scss';
// images/icons //
import { Line2 } from '../../images/icons/Line2'
import { Macbook } from '../../images/pictures/Macbook'
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi'
import background from '../../images/pictures/background.png'


import shonic from '../../images/pictures/shonic2.png'
import shonic_search from '../../images/pictures/shonic_search.png'
import shonic_product from '../../images/pictures/shonic_product.png'
import shonic_order from '../../images/pictures/shonic_order.png'
import shonic_account from '../../images/pictures/shonic_account.png'

const Shonic = () => {
    const [number, setNumber] = useState(1)
    const data = [
        {
            id: 1,
            title: "Homepage",
            next: "Package",
            prev: "Documentation",
            src: shonic,
            desc1: `Welcome to Shonic! Our dedicated team has poured their passion for craftmanship into creating this lovely electronic website. This website was created using ReactJS & Redux as the backbone of the frontend and SCSS as the makeup for the frontend ! In this carefully made website we can't wait to share with you what we have in our shelves!`,
            desc2: `On our homepage there are dozens of features that we have patiently created to help you have a great user experience whilst you're on our site! Features such as search product to help you quickly find the electronic goods thats been on the back of your mind, features such as the product reccomendations to help you find what electronic goods you might like, features such as selected brands to help you quickly navigate to find the products of your chosen brand, along with so many other features that were specifically made to help you in your journey of finding the right electronic goods!`        
        }, 
        {
            id: 2,
            title: "Search",
            src: shonic_search,
            desc1: "Congrats! You have found and successfully used our search feature. As you can see, this feature is pretty self explanatory as you are shown the products that you've previously searched for!",
            desc2: "In this page we have features to help you navigate more easily on our site! The filter feature has some parameters that you can use such as the price option to help you find electronic goods within your budget, the discount option to only show the products with discount, and also the rating option to help you find the best products on our site!  There's also another feature such as the viewing feature, it was made so that you can see the products in the selected order such as the latest products, the cheapest products, or the most expensive products if you're feeling fancy!"
        }, 
        {
            id: 3,
            title: "Product Detail",
            src: shonic_product,
            desc1: "So a certain product has caught your attention and now you want to find out more about it to see if it's a match- I mean, if the product has the specs you're looking for and if it's within your budget! Worry not because this is exactly what that page is, oh and if you're feeling a bit suspicious you can see the ratings and the reviews of the product to help you ease your trust issues- I mean, if the product is legit. Dont forget to add it to your cart if it's a match after all ;)!",
            desc2: ""
        },
        {
            id: 4,
            title: "Order Page",
            src: shonic_order,
            desc1: "Wow! Would you look at that?! I know, I know, it's hard to buy only one electronic product when there are so many good products available at the tip of your finger, this page is specifically made to help you with that! You can see what products you've ordered so far and their payment status, make sure to pay them or they will disappear from this page!",
            desc2: ""
        },
        {
            id: 5,
            title: "Account",
            src: shonic_account,
            desc1: "So you want to change certain informations about your account? Worry not for we have created the feature to help you with that! On this page you can change not only your name but also your number, birthday, address, and your gender! But please, dont use some fake informations about yourself or your order might not get approved :( ",
            desc2: ""
        },
    ]
    const [temp, setTemp] = useState(data)

    const cont = () => {
        console.log("ini cont")
        //setNumber(number+1)
        if(number === data.length){
            setNumber(1)
        } else {
            setNumber(number+1)
        }
        console.log("number", number, "data length",data.length)
    }

    const prev = () => {
        console.log("ini prev")
        if(number === 1) {
            setNumber(data.length)
        } else {  
            setNumber(number-1)
        }
        console.log("number", number)
    }
    console.log("numberrrrrrrr", number)
    return(
        <>
            <div className={styles.template_header_top} style={{ backgroundImage: `url(${background})`,  background: `linear-gradient(rgba(0, 0, 0, 0), transparent), url(${background})`, backgroundRepeat: `no-repeat`, backgroundSize: `cover`, backgroundPosition: `center`, height: `37rem`}}>
            </div>
            <div className={styles.template_container_shonic}>
                {/* {temp.map((data) => {
                        return(
                            // <p>{data['title']}</p>
                            <>
                          {data['id'] === 1 ? <p>yes</p> : <p>no</p>}
                        </>
                        )
                })} */}
                <div className={`${styles.template_container_details} container`}>
                    <Fade top cascade>
                        <div className={styles.template_header_text}>
                            <a href="https://drive.google.com/file/d/1FhpFnKCrz9KZAwt16RERs1EfLFRboDu5/view">DEMO</a>
                            <h1 className={`${styles}`}>Shonic</h1>
                            <a href="https://gitlab.com/shonic/shonic-website">REPO</a>
                        </div>
                    </Fade>
                </div>
                {temp.map((data) => {
                        return(
                            // <p>{data['title']}</p>
                            <>        
                            {data['id'] === number ? 
                            <>
                            <div className={styles.template_mac}>
                                <div className={styles.template_details}>
                                            <Macbook/>
                                            <div className={styles.template_images}>
                                                {/* <Fade big> */}
                                                    <img src={data['src']} className={styles.work_image} />
                                                {/* </Fade> */}
                                            </div>
                                </div>
                            </div>
                            <div className={styles.template_homepage}>
                                <Fade big>
                                <ul>
                                    <li onClick={(e) => prev()}><BiLeftArrowAlt className={styles.arrow} style={{ color: 'Blue', position: 'relative',   fontSize: '32px' }} /></li>
                                    <li>{data['title']}</li>
                                    <li onClick={(e) => cont()}><BiRightArrowAlt style={{ color: 'Blue', position: 'relative',   fontSize: '32px' }} /></li>
                                </ul>
                                </Fade>
                                <Line2/>
                                <Fade big>
                                <div className={styles.template_details}>
                                    <p>{data['desc1']}</p> 
                                    <p>{data['desc2']}</p>
                                </div>
                                </Fade>
                                <Line2/>
                                <Fade bottom cascade>   
                                    <Link to={`/`} className={styles.button}>
                                        <button> * Back to Home *</button>
                                    </Link>
                                </Fade>
                            </div>
                            </>
                            : null
                            }
                        </>
                        )
                })}
                 {/* <div className={styles.template_mac}>
                    <div className={styles.template_details}>
                        <Macbook/>
                        <div className={styles.template_images}>
                            <img src={ardawalika} className={styles.work_image} />
                        </div>
                    </div>
                </div> */}
                {/* <div className={styles.template_homepage}>
                    <ul>
                        <li>next</li>
                        <li>homepage</li>
                        <li>next</li>
                    </ul>
                    <Line2/>
                    <div className={styles.template_details}>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tincidunt augue ac metus aliquam aliquet. Donec non fringilla purus. Suspendisse ac iaculis tellus, et convallis arcu. Vivamus sed laoreet velit, in malesuada massa. Cras dapibus nec mauris ut feugiat. Nulla facilisi. Etiam nec risus ut felis feugiat sollicitudin non ac lorem. Ut vel purus blandit, pharetra velit ac, lacinia elit. Sed eget felis lobortis, lobortis odio vel, consequat velit. Duis porta, nisl ac ultrices consequat, nisl nisl convallis nunc, quis convallis ipsum magna sed lacus. Nunc fringilla quis libero et sagittis.</p> 
                        <p>Nullam vel elementum sapien. Cras efficitur tellus ut ipsum varius dictum nec vel ligula. Suspendisse lobortis dictum dolor, ut commodo diam volutpat et. Suspendisse porta turpis ut arcu pretium faucibus. Cras placerat augue faucibus, vulputate leo non, elementum ipsum. Fusce at euismod odio, ut vehicula ligula. Pellentesque aliquet fermentum lectus nec vulputate. Fusce enim nibh, posuere nec blandit eu, lacinia a risus. Curabitur suscipit ipsum et posuere tristique. Proin ac erat blandit, luctus mauris a, tincidunt libero. Ut tincidunt at justo in ultricies. Quisque lacus mauris, ornare nec rutrum in, posuere sit amet risus. Cras vitae fringilla ligula, egestas fermentum mauris. Aliquam feugiat odio at ex tincidunt, at pharetra sem sagittis. Cras et scelerisque ipsum.</p>    
                    </div>
                    <Line2/>
                    <Link to={`/`} className={styles.button}>
                        <button> * Back to Home *</button>
                    </Link>
                </div> */}
            </div>
        </>
    )
}

export default Shonic